import { helper } from '@ember/component/helper';

import { isNumeric } from 'rise-ui/utils/number.js';

export default helper(function localeNumHelper([ num ]) {
  if (isNumeric(num)) {
    num = Number(num).toLocaleString('en-US', { maximumFractionDigits: 2 });
  }
  return num;
});
